import Vue from 'vue';
import axios, { CancelToken } from 'axios/dist/axios';
import { convertToSnakeCase } from '@/utils/util';
import { ERROR_CODE } from '@/constants';
import { addEnvHeader } from './util';

let source = CancelToken.source();

// 创建axios实例
const service = axios.create({
    baseURL: process.env.QBOT_API_BASE_URL,
    timeout: 600 * 1000,
    withCredentials: true
});

const requestInterceptorFun = (config) => {
    // qbot接口按路径分模块
    let urlPrefix = '/qbot/chat/';
    if (['Login', 'Logout', 'SendVerifyCodeNew'].includes(config.url)) {
        urlPrefix = '/qbot/login/';
    } else if (['DescribeStorageCredential', 'GetDisplayDocs', 'GetDocPreview', 'DescribeRefer'].includes(config.url)) {
        urlPrefix = '/qbot/admin/';
    } else if (['DescribeRobotInfo'].includes(config.url)) {
        urlPrefix = '/qbot/api/';
    }
    // qbot接口名为小写首字母
    config.url = config.url.charAt(0).toLowerCase() + config.url.slice(1);
    config.url = `${urlPrefix}${config.url}`;
    config.cancelToken = source.token; // 全局cancelToken
    config.data = convertToSnakeCase(config.data);
    config = addEnvHeader(config);
    return config;
};

// request拦截器
service.interceptors.request.use(requestInterceptorFun, error => {
    console.log('【request error】' + error);
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use((response) => {
    let { code, message = '', data } = response.data || {};
    /**
     * api代理返回19001,表示鉴权错误。例如：无登录态，或登录态失效
     */
    if ([19001, 450006].includes(code)) {
        // 跳转腾讯云登录页
        toLoginPage();
        return Promise.reject(new Error(`[${code}]${message}`));
    }
    // 获取cos文件，返回data为string内容
    if (Object.prototype.toString.call(data) === '[object String]') {
        return Promise.resolve(data);
    }

    if (code !== 0) {
        // 分享链接失效时，需要特殊处理，展示链接失效页
        if (String(code) === ERROR_CODE.INVALID_SHARECODE) {
            return Promise.reject(ERROR_CODE.INVALID_SHARECODE); // 抛出异常
        }
        if (!response.config.url.includes('/qbot/admin/describeRefer')) {
            handleError(code, message, response.config.data);
            return Promise.reject(new Error(`[${code}]${message}`)); // 抛出异常
        }
    }
    if (response.config.url.includes('/qbot/admin/describeRefer')) {
        data = convertToSnakeCase(response.data.Response);
    } else {
        data = convertToSnakeCase(data);
    }

    return Promise.resolve(data);
}, error => {
    if (axios.isCancel(error)) {
        console.log('【isCancel error】');
        return new Promise(() => { });
    } else {
        if (error.response) {
            const { data } = error.response;
            data.msg = data.message;
            console.log('【response error】' + JSON.stringify(data));
            return Promise.reject(data);
        }
        return Promise.reject(error);
    }
});

export const toLoginPage = () => {
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_avatar');
    const { href } = window.location;
    window.location.hash = `#/login?redirect_url=${encodeURIComponent(href)}`;
    window.location.reload();
};

export const handleError = (code, message, params = {}) => {
    Vue.prototype.$message.error(message, JSON.parse(params));
    if (String(code) === ERROR_CODE.ROBOT_NOT_EXIST) { // 机器人不存在
        Vue.prototype.$message.error(message || '获取会话ID失败，请重试');
        return new Promise(() => { });
    } else if (String(code) === ERROR_CODE.AUTH_FAIL) { // 权限不足
        console.log('error:', '权限不足');
        return new Promise(() => { });
    }
};
export default service;



// WEBPACK FOOTER //
// ./src/utils/ajax/qbot.js